import {
  Mesh,
  BoxGeometry,
  Vector2,
  MeshNormalMaterial,
} from 'three'
import { map } from "../utils/utilsFunc";

import Accordion from '../components/Accordion';
import playlistData from '../../content/data';
export default class Page {
  constructor({ parent, size }) {

    console.log('Refresh the page for new BIRDS !')

    this.parent = parent;
    this.size = {
      x: size.x,
      y: size.y
    }
    this.loaded = false

    this.texturesToLoad = []
    this.ratioScreen = this.size.x / this.size.y

    this.db = new Vector2(window.innerWidth, window.innerHeight)

    this.params = {
      enableRotation: true
    }

    // this.initData()

    this.bindMethods()
    this.getElems()

    // Extract all images from data for preloading
    this.extractImagesToLoad()

    // The rest of the initialization will happen in ready() after images are loaded
  }

  initData() {
    const { accordionTemplate, playlistContainer, playlistContainerPlaylist, playlistContainerMix, playlistAppendDiv, mixAppendDiv } = this


    if (import.meta.env.MODE === 'playlist') {
      playlistContainerMix.remove()
    } else if (import.meta.env.MODE === 'mix') {
      playlistContainerPlaylist.remove()
    }


    for (let i = 0; i < playlistData.playlist.length; i++) {
      if (import.meta.env.MODE === 'playlist' && playlistData.playlist[i].type === 'mix') continue

      const temp = accordionTemplate.cloneNode(true)
      temp.name = playlistData.playlist[i].nameParams
      temp.type = playlistData.playlist[i].type
      const content = temp.querySelector('.playlist__content')
      const item = temp.querySelector('.playlist__item')
      const tempItem = item.cloneNode(true)

      content.removeChild(item)

      const isMonthly = playlistData.playlist[i].isMonthly

      const tempCover = temp.querySelector('.playlist__cover')

      tempCover.children[0].src = playlistData.playlist[i].cover

      temp.querySelector('.playlist__title').textContent = playlistData.playlist[i].name

      if (playlistData.playlist[i].date) {
        const date = new Date();
        const newDate = playlistData.playlist[i].date;

        newDate.setDate(newDate.getDate() + 5);

        if (date < newDate) {
          temp.querySelector('.playlist__new').style.display = 'flex';
        }
      }


      for (let j = 0; j < playlistData.playlist[i].data.length; j++) {
        const cloneTempItem = tempItem.cloneNode(true)
        cloneTempItem.querySelector('.playlist__item__link').href = playlistData.playlist[i].data[j].link
        if (!isMonthly) cloneTempItem.querySelector('.playlist__item__cover').src = playlistData.playlist[i].data[j].picture
        else cloneTempItem.querySelector('.playlist__item__cover').remove()
        if (playlistData.playlist[i].data[j]) {
          cloneTempItem.querySelector('.playlist__item__title').textContent = playlistData.playlist[i].data[j].name
        } else cloneTempItem.querySelector('.playlist__item__title').textContent = playlistData.playlist[i].name + ' ' + playlistData.playlist[i].data[j].name
        if (playlistData.playlist[i].data[j]) {
          cloneTempItem.querySelector('.playlist__item__plateform').classList.remove(cloneTempItem.querySelector('.playlist__item__plateform').classList[1])
          cloneTempItem.querySelector('.playlist__item__plateform').classList.add(playlistData.playlist[i].data[j].plateform)


        } else cloneTempItem.querySelector('.playlist__item__plateform').classList.add(playlistData.playlist[i].data[j].plateform)
        content.appendChild(cloneTempItem)
      }

      if (temp.type === 'mix') {
        mixAppendDiv.appendChild(temp)
      } else if (temp.type === 'playlist') {
        playlistAppendDiv.appendChild(temp)
      }

      const spaceEl = document.createElement('span')
      spaceEl.classList.add('playlist__offset')

      temp.appendChild(spaceEl)
    }

    // Remove the template accordion element after all clones are created
    if (accordionTemplate) accordionTemplate.parentElement.removeChild(accordionTemplate)

    this.accordionEl = document.querySelectorAll('.playlist-el');

    // Initialize accordeons after DOM is created
    this.searchParams = new URLSearchParams(window.location.search);

    for (let i = 0; i < this.accordionEl.length; i++) {
      this.accordion = new Accordion(this.accordionEl[i], this.searchParams)
    }
  }

  extractImagesToLoad() {
    // Extract all cover images from playlistData
    playlistData.playlist.forEach(playlist => {
      // Add the main cover
      if (playlist.cover) {
        this.texturesToLoad.push(playlist.cover);
      }

      // Add images from playlist data items (for mixes that have individual covers)
      if (playlist.data) {
        playlist.data.forEach(item => {
          if (item.picture && !this.texturesToLoad.includes(item.picture)) {
            this.texturesToLoad.push(item.picture);
          }
        });
      }
    });
  }

  bindMethods() {
    this.update = this.update.bind(this)
    this.resize = this.resize.bind(this)
  }


  getElems() {
    this.accordionEl = document.querySelectorAll('.playlist-el');
    this.birdTop = document.querySelector('.bird-top')
    this.birdBottom = document.querySelector('.bird-bottom')

    this.playlistContainer = document.querySelector('.playlist-container-base');
    this.playlistContainerPlaylist = document.querySelector('.playlist-container-playlist');
    this.playlistContainerMix = document.querySelector('.playlist-container-mix');

    this.playlistAppendDiv = this.playlistContainerPlaylist.querySelector('.playlist-container');
    this.mixAppendDiv = this.playlistContainerMix.querySelector('.playlist-container');

    // Store the template accordion element before it gets removed
    this.accordionTemplate = document.querySelector('.playlist-el');
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }


  init() {
    return new Promise((resolve, reject) => {
      const promises = []

      // Add image preloading to the promises
      if (this.texturesToLoad.length > 0) {
        promises.push(this.preloadImages(this.texturesToLoad));
      }

      Promise.all(promises)
        .then(() => {
          resolve();
        })
        .catch(reject);
    });
  }

  preloadImages(imagePaths) {
    return new Promise((resolve, reject) => {
      const promises = imagePaths.map(imagePath => {
        return new Promise((resolveImg, rejectImg) => {
          const img = new Image();
          img.onload = () => resolveImg(img);
          img.onerror = () => rejectImg(new Error(`Failed to load image: ${imagePath}`));
          img.src = imagePath;
        });
      });

      Promise.all(promises)
        .then(resolve)
        .catch(reject);
    });
  }

  initAssets() {
    return Promise.resolve()
  }

  ready({ textures, models, hdr, KTX2 }) {
    // Now that all images are loaded, we can safely initialize the data and DOM
    this.initData();

    // Initialize random birds
    const firstRandom = this.getRandomInt(11) + 1
    const secondRandom = this.getRandomInt(11) + 1

    if (this.birdTop.classList[1]) this.birdTop.classList.remove(this.birdTop.classList[1])
    if (this.birdBottom.classList[1]) this.birdBottom.classList.remove(this.birdBottom.classList[1])

    this.birdTop.classList.add('bird-' + firstRandom)
    this.birdBottom.classList.add('bird-' + secondRandom + '-reverse')
  }

  resize(size) {
    this.size = {
      x: size.x,
      y: size.y
    }
    this.ratioScreen = this.size.x / this.size.y
  }

  debugMode(pane) {
    const three = pane.addFolder({
      title: 'Three',
    });

    three.addBinding(this.params, 'enableRotation', {
    }).on('change', ({ value }) => {
      this.params.enableRotation = value
    })
  }

  update({ time, deltaTime }) {

  }
}